import axios from "axios";
import { dispatch } from "store";
import {
  GET_ALL_STAFF_SUPPORT,
  GET_STAFF_SUPPORT_DATA,
  GET_ALL_REPLY,
} from "../actions";

const PROXY = process.env.REACT_APP_URL + "api/";

export const getAllStaffSupport = (page, limit, search) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${PROXY}admin/staff-support/all?page=${page}&limit=${limit}&search=${search}`
    );
    dispatch({
      type: GET_ALL_STAFF_SUPPORT,
      payload: res.data.result,
    });
    return res
  } catch (err) {
    console.error(err);
  }
};

export const getStaffSupportDetails = (id) => async (dispatch) => {
  const res = await axios.get(`${PROXY}admin/staff-support/detail/${id}`);
  dispatch({
    type: GET_STAFF_SUPPORT_DATA,
    payload: res.data.result,
  });
  return res.data.result;
};

export const handleStaffTicket = (id, status) => async () => {
  const res = await axios.put(
    `${PROXY}admin/staff-support/change-status/${status}/${id}`
  );
  return res;
};

export const getAllReply = (data) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${PROXY}staff-support-reply/staff/get?ticket=${data}`
    );
    dispatch({
      type: GET_ALL_REPLY,
      payload: res.data.result,
    });
  } catch (err) {
    console.log(err);
  }
};

export const addReply = (data) => async () => {
  const res = await axios.post(`${PROXY}staff-support-reply/reply`, data);
  return res;
};

export const getStaffSupportNotification = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}notification/staff-support`);

  return res.data.result;
};
